import * as React from 'react';
import styled from 'styled-components';
import AnimatedInput from '../AnimatedInput/AnimatedInput';
import Button from '../button/onlineButton';
import Subtitle from '../onlineSubtitle/onlineSubtitle';

// ############################ Imported from Old UI ###########################

export interface IFormProps {
  children: JSX.Element[] | JSX.Element;
  dataAt?: string;
  tabIndex?: number;
  className?: string;
  fontWeight?: string;
  fontFamily?: string;
  alignLeft?: boolean;
  color?: string;
}

const SFormSection = styled.form(
  () => `
    display: flex;
    & .with-error {
      >div, >span, & label {
        margin-bottom: 25px;
      }

      & fieldset span {
        left: 12px;
        top: 42px;
        position: absolute;
      }
    }
`
);

export const FormTitle = styled.div(
  ({ theme }) => `
  padding: 40px 30px;
  color: ${theme.colors.primaryBackground};
  text-align: center;
`
);

const SDetailsWrapper = styled.div(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: auto;
    margin-top: 80px;
    padding: 5%;
    width: 60%;
    min-width: 360px;
    max-width: 700px;
    height: auto;
    overflow: hidden;
    box-shadow: 0px 6px 14px -6px rgba(24, 39, 75, 0.12), 0px 10px 32px -4px rgba(24, 39, 75, 0.1);
    border-radius: 25px;
    background: ${theme.colors.white};
    @media only screen and ${theme.device.max.laptopS} {

    & section {
      flex-direction: column !important;
    }

    & .empty {
      display: none!important;
    }
  `
);

export const FormField = styled.div(
  ({ theme }) => `
    padding: 5px;
    align-items: center;
    color: ${theme.colors.primaryBackground};
    max-width: 360px;
    width: 100%;
    min-height: 50px;

    >label {
      font-weight: ${theme.font.weight.bold};
      font-family: Poppins;
      font-size: 14px;
      margin-right: 30px;
    }

    & input {
      width: 220px;
    }
  `
);

export const ActionButton = styled(Button)(
  ({ theme }) => `
  margin-bottom: ${theme.spacing.large}px;
  & button {

    width: 100%;
    height: 44px;
    margin-bottom: 44px;
    & span {
      font-family: Poppins;
      font-style: normal;
      font-weight: bold;
      font-size: 14px;
      line-height: 21px;
      display: flex;
      align-items: center;
      text-align: center;
    }
  }
`
);

export const HelpText = styled.p(
  ({ theme }) => `
  text-align: center;
  font-size: ${theme.font.size.small};
  color: ${theme.colors.mediumGray};
`
);

export const DisabledText = styled.div(
  ({ theme }) => `
  text-align: center;
  font-size: ${theme.font.size.smallMedium};
  font-weight: 500;
  margin-top: -15px;
  color: ${theme.colors.primaryBackground};
`
);

export const DescriptionText = styled.div(
  ({ theme }) => `
  font-size: ${theme.font.size.smallMedium};
  color: ${theme.colors.mediumGray};
  margin-bottom: 50px;
`
);

export const DescriptionTitle = styled(Subtitle)(
  ({ theme }) => `
  font-family: 'Poppins';
  font-weight: ${theme.font.weight.bolder};
  text-align: left;
  margin-top: 20px;
  font-size: 18px;
`
);

export const DescriptionSubtitle = styled(Subtitle)(
  ({ theme }) => `
font-family: Poppins;
  font-size: 18px;
  line-height: 25px;
`
);

export const FormValue = styled.span(
  ({ theme }) => `

`
);

export const FormTable = styled.div(
  ({ theme }) => `
    margin-top: 10px;
    border: 1px solid ${theme.colors.grayWhite};
    border-radius: 15px;
    overflow: hidden;
    color: ${theme.colors.primaryBackground};
    background-color: ${theme.colors.lightBackground};
    padding: 20px;

  & .tr {
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    min-width: 100%;
    max-width: 100%;
    & .th {
      font-weight: ${theme.font.weight.bolder};
      font-size: ${theme.font.size.smallMedium};
      margin: 0;
    }

    & .vertical.th {
      max-width: 160px;
      min-width: 160px;
      font-weight: ${theme.font.weight.normal};
    }
  }


  & .td, & .th {
    line-height: 20px;
    padding: 0 20px;
    height: 35px;
    display: flex;
    align-items: center;
    flex-grow: 2;
    text-align: left;
    margin-right: 40px;
    min-width: 30%;
    max-width: 30%;
    white-space: nowrap;
    margin: 0;
    font-size: ${theme.font.size.small};
    &.input-field {
      max-width: 100%;
    }
    &.small {
      min-width: 20%;
      max-width: 20%;
    }
    &.large {
      min-width: 40%;
      max-width: 40%;
    }
    & input {
      font-size: ${theme.font.size.small};
      font-weight: ${theme.font.weight.light};
      padding: 0 10px;
      background: ${theme.colors.white};
    }
    &>div {
      width: 100%;
    }
    ${AnimatedInput} {
      width: 100%;
      &>div {
        width: 100%;
        & span {
          position: absolute;
        }
      }
    }
  }
`
);

export const FormTableHorizontalRows = styled.div(
  ({ theme }) => `
    margin-top: 10px;
    border: 1px solid ${theme.colors.grayWhite};
    border-radius: 15px;
    overflow: hidden;
    color: ${theme.colors.primaryBackground};
    background-color: ${theme.colors.lightBackground};
    padding: 20px;

  & .tr {
    font-size: 14px;
    display: flex;
    align-items: center;
    flex: 1 1 0;
    & .th {
      font-weight: ${theme.font.weight.bolder};
      font-size: ${theme.font.size.smallMedium};
      margin: 0;
    }

    & .vertical.th {
      font-weight: ${theme.font.weight.normal};
    }
  }

  .td {
     flex: 1 1 0;
  }


  & .td, & .th {
    line-height: 20px;
    padding: 0 20px;
    height: 35px;
    display: flex;
    align-items: center;
    text-align: left;
    margin-right: 40px;
    white-space: nowrap;
    margin: 0;
    font-size: ${theme.font.size.small};

    &.small {
      flex: 1 0 250px;
    }
    &.large {
      flex: 1 0 350px;
    }
    & input {
      font-size: ${theme.font.size.small};
      font-weight: ${theme.font.weight.light};
      padding: 0 10px;
      background: ${theme.colors.white};
    }
  }
`
);

export const FormAction = styled.div(
  ({ theme }) => `
    color: ${theme.colors.primaryBright};
    font-weight: ${theme.font.weight.bold};
    padding: 20px;
    cursor: pointer;
`
);

export const FormBullet = styled.span(
  ({ theme }) => `
  background: ${theme.colors.bulletBackground};
  border-radius: 50px;
  color: ${theme.colors.primaryBright};
  font-weight: ${theme.font.weight.medium};
  padding: 3px 8px;
`
);

export const OnlineForm: React.FC<IFormProps> = (props) => (
  <SFormSection>
    <SDetailsWrapper>{props.children}</SDetailsWrapper>
  </SFormSection>
);
